// extracted by mini-css-extract-plugin
export default {"text":"SuccessfulReportPage_text__+OT+A","header":"SuccessfulReportPage_header__rjBym"};